import React, { useEffect, useState } from "react";
import styles from "./VerifyOtpStepBVN.module.scss";
import SignUpFormWrapper from "./wrapper/SignUpFormWrapper";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearState, setActiveStep, userInfoSelector } from "../../stores/slices/sign-up-slice";
import { AppDispatch } from "../../stores/store";
import { ApplicationRoutes } from "../../routes";
import { toast } from "react-toastify";
import OtpInput from "react-otp-input";
import TimerButton from "./components/timer-button/TimerButton";
import { useForm } from "react-hook-form";
import { useResendOtpMutation, useVerifyOtpMutation } from "../../service/customer-service";
import { logIn } from "../../stores/slices/current-user-slice";
import CustomerSignUpFormWrapper from "./wrapper/CustomerSignUpFormWrapper";

type Props = {
	getOtp: (otp: string) => Promise<void>,
	getBack: () => void
	title?: string
	subtitle?: string
};

const VerifyOtpStepBVN: React.FC<Props> = (props: Props) => {
	const otpLength = 6;

	const [verifyOtp, { isLoading: isVerifingOtp }] = useVerifyOtpMutation();
	const [resendOtp, { isLoading: isResendingOtp }] = useResendOtpMutation();

	const dispatch = useDispatch<AppDispatch>();

	const navigate = useNavigate();

	const userInfo = useSelector(userInfoSelector);

	const {
		handleSubmit,
		watch,
		setValue,
		formState: { errors, isValid, isSubmitted },
	} = useForm<{
		otp: string;
	}>({
		defaultValues: {
			otp: "",
		},
		reValidateMode: "onSubmit",
		mode: "onBlur",
	});

	const onBack = () => {
		props.getBack();
	};

	useEffect(() => {
		dispatch(setActiveStep(2));
	}, [dispatch]);
	
	const handleResendOtp = async () => {
		try {
			await resendOtp({ customerSignupId: userInfo.signUpId }).unwrap();

			toast.success("OTP sent successfully");
		} catch (error: any) {
			toast.error(error.data?.title || "Failed to sign up. Please try again.");
		}
	};

	const handleVerify = async () => {
		props.getOtp(watch('otp'));
	};

	return (
		<CustomerSignUpFormWrapper
			title={props.title ?? "Email Verification"}
			subtitle={props.subtitle ?? "Please verify your email to proceed"}
			onBack={onBack}
			onNext={handleSubmit(handleVerify)}
			nextButtonDisabled={isSubmitted && !isValid}
			isLoading={isVerifingOtp || isResendingOtp}
		>
			<div className={styles.container}>
				<div className={styles.inputLabel}>A 6(six) digit OTP has been sent to</div>
				<div className={styles.email}>{userInfo.email}</div>
				<OtpInput
					value={watch("otp")}
					inputType={"number"}
					onChange={value => {
						setValue("otp", value, {
							shouldValidate: true,
							shouldDirty: true,
							shouldTouch: true,
						});
					}}
					numInputs={otpLength}
					containerStyle={styles.otpContainer}
					renderInput={props => <input {...props} />}
				/>
				{errors.otp && <div className={styles.errorMessage}>{errors.otp?.message}</div>}
				<div className={styles.footer}>
					<TimerButton timerLength={59} onClick={handleResendOtp} />
					{/* <button className={`${styles.changeEmailButton}`} onClick={handleChangeEmail}>
						Change Email
					</button> */}
				</div>
			</div>
		</CustomerSignUpFormWrapper>
	);
};

export default VerifyOtpStepBVN;
